export const DELETE_CONTRACT_MODAL_NAME = 'DELETE_CONTRACT_MODAL_NAME';
